import axios from 'axios';
import { downloadFile } from 'components/utils';
import filtersStore from 'store/filters';
import { getUnitsApi, uploadUnitsApi, unitsScanApi, syncUnitsApi, downloadUnitsApi, getUnitPriceHistoryApi, getUnitContactsApi, sendUnitContactMetricsApi, checkNumberAvailabilityApi, deleteUnitsPlansApi, deleteSoldOutUnitApi, deleteUnitsStubAllAdminApi, deleteUnitsStubBatchAdminApi, } from '../api';
const unitsActions = {
    getProjectUnits: async (projectId, { signal, setState }) => {
        try {
            const filters = filtersStore.getState().filtersData;
            const { data: res } = await getUnitsApi(projectId, filters, signal);
            setState((state) => {
                state.project.units = res;
            });
            return res;
        }
        catch (error) {
            // @ts-ignore
            throw error?.response?.data;
        }
    },
    clearProjectUnits: async (_payload, { setState }) => {
        try {
            setState((state) => {
                state.project.units = [];
            });
        }
        catch (error) {
            // @ts-ignore
            throw error?.response?.data;
        }
    },
    uploadProjectUnits: async ({ projectId, file }, { setState }) => {
        const form = new FormData();
        form.append('file', file);
        try {
            const { data: res } = await uploadUnitsApi(projectId, form);
            setState((state) => {
                state.project.units = res;
            });
            return res;
        }
        catch (error) {
            // @ts-ignore
            throw error?.response?.data;
        }
    },
    unitsScan: async ({ projectId, file }) => {
        const form = new FormData();
        form.append('file', file);
        try {
            const { data } = await unitsScanApi({ projectId, data: form });
            return data.rows;
        }
        catch (error) {
            // @ts-ignore
            throw error?.response?.data;
        }
    },
    syncProjectUnits: async ({ projectId, payload }) => {
        try {
            const { data } = await syncUnitsApi(projectId, { rows: payload });
            return data;
        }
        catch (error) {
            // @ts-ignore
            throw error?.response?.data;
        }
    },
    downloadUnits: async (projectId) => {
        try {
            const { data } = await downloadUnitsApi(projectId);
            downloadFile(data, 'units.csv');
            return data;
        }
        catch (error) {
            // @ts-ignore
            throw error?.response?.data;
        }
    },
    getUnitPriceHistory: async (unitId, { setState }) => {
        setState((state) => {
            state.unitsPriceHistory[unitId] = null;
        });
        try {
            const { data: res } = await getUnitPriceHistoryApi(unitId);
            setState((state) => {
                state.unitsPriceHistory[unitId] = res;
            });
            return res;
        }
        catch (error) {
            // @ts-ignore
            throw error?.response?.data;
        }
    },
    getUnitContacts: async (unitId) => {
        try {
            const { data } = await getUnitContactsApi(unitId);
            return data;
        }
        catch (err) {
            if (axios.isAxiosError(err))
                throw err.response?.data;
            throw err;
        }
    },
    sendUnitContactMetrics: async (unitId) => {
        try {
            await sendUnitContactMetricsApi(unitId);
        }
        catch {
            // fire-and-forget: ошибка не должна попадать в UI
        }
        return unitId;
    },
    checkNumberAvailability: async (payload) => {
        try {
            const { data } = await checkNumberAvailabilityApi(payload);
            if (!data.isAvailable)
                throw data;
            else
                return data;
        }
        catch (error) {
            throw error.reason;
        }
    },
    deleteUnitsPlans: async (projectId) => {
        try {
            const { data } = await deleteUnitsPlansApi(projectId);
            return data;
        }
        catch (error) {
            // @ts-ignore
            throw error;
        }
    },
    deleteSoldOutUnit: async ({ projectId, unitNumber }, { setState }) => {
        try {
            const res = await deleteSoldOutUnitApi(projectId, unitNumber);
            setState((state) => {
                state.project.units = state.project.units.filter((unit) => unit.number !== unitNumber);
            });
            return res.data;
        }
        catch (error) {
            // @ts-ignore
            throw error?.response?.data;
        }
    },
    deleteUnitsStubBatch: async ({ projectId, ids }, { setState, signal }) => {
        try {
            const res = await deleteUnitsStubBatchAdminApi(projectId, { ids }, signal);
            setState((state) => {
                state.project.units = state.project.units.filter((unit) => !ids.includes(unit.id));
            });
            return res.data;
        }
        catch (err) {
            const error = err;
            throw error.response?.data.message ?? error;
        }
    },
    deleteUnitsStubAll: async ({ projectId }, { setState, signal }) => {
        try {
            const res = await deleteUnitsStubAllAdminApi(projectId, signal);
            setState((state) => {
                state.project.units = state.project.units.filter((unit) => unit.status !== 'stub');
            });
            return res.data;
        }
        catch (err) {
            const error = err;
            throw error.response?.data.message ?? error;
        }
    },
};
export default unitsActions;
